import React from "react";
import search from "../images/icon-search.svg";

const Searchbar = ({ searchOption, searchWord }) => {
	const startSearch = () => {
		return searchWord(document.getElementById("search-icon").nextSibling.value);
	};

	return (
		<form className="search-bar">
			<img id="search-icon" onClick={startSearch} src={search} alt="Search icon"></img>
			<input id="search-bar" onChange={startSearch} className="search" placeholder={searchOption} autoComplete="off"></input>
		</form>
	);
};

export default Searchbar;
